import { Form, InputGroup } from 'react-bootstrap'
import { BsSearch, BsXLg } from 'react-icons/bs'

export default function InputSearchCustom({
  value,
  onChange,
  placeholder = ''
}) {
  return (
    <InputGroup>
      <Form.Control
        placeholder={placeholder}
        className="border-end-0 fw-light"
        value={value}
        onChange={(e) => {
          onChange(e.target.value)
        }}
      />
      {value ? (
        <InputGroup.Text
          id="basic-addon1"
          className="border-start-0 pointer-event bg-white"
          onClick={() => {
            onChange('')
          }}
        >
          <BsXLg className="opacity-50 text-title" />
        </InputGroup.Text>
      ) : (
        <InputGroup.Text id="basic-addon1" className="border-start-0 bg-white">
          <BsSearch className="opacity-50 text-title " />
        </InputGroup.Text>
      )}
    </InputGroup>
  )
}
